import React from "react";
import './ButtonStyles.css';

const Button = ({ onClick, children, className = "", ...props }) => {
  return (
    <button
      type={"button"}
      className={`${className} buttonNew`}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
